import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const Navbar = () => {
  const [sticky, setSticky] = useState(false);
  const [open, setOpen] = useState(false);
  const menuLinks = [
    // { name: "HOME", link: "/" },
    { name: "ABOUT", link: "#about" },
    { name: "PROJECTS", link: "#projects" },
    { name: "SKILLS", link: "#skills" },
    { name: "CONTACT", link: "#contact" },
    // { name: "BLOG", link: "/blog" },
  ];
  useEffect(() => {
    window.addEventListener("scroll", () => {
      const nav = document.querySelector("nav");
      window.scrollY > 0 ? setSticky(true) : setSticky(false);
    });
  }, []);
  return (
    <nav
      className={`fixed w-full left-0 top-0 z-[999] mx-auto ${
        sticky ? "bg-indigo-600/90  text-gray-600" : "text-white"
      }`}
    >
      <div className="flex items-center justify-between">
        <div className="mx-7">
          <Link to="/">
            <h4
              className={`md:text-4xl text-xl uppercase font-bold ${
                sticky ? "text-gray-300" : "text-gray-200"
              }`}
            >
              Nahid
              <span
                className={`${sticky ? "text-indigo-900" : "text-indigo-600"}`}
              >
                {" "}
                Parvez
              </span>
            </h4>
          </Link>
        </div>
        <div
          className={` ${
            sticky ? "md:bg-white/0 bg-white" : "bg-indigo-600"
          } text-gray-200 md:block hidden px-7 py-2`}
        >
          <ul className="flex items-center gap-1 py-2 text-lg">
            <li>
              <Link to="/" className="px-6 hover:text-indigo-400">
                HOME
              </Link>
            </li>
            {menuLinks?.map((menu, i) => (
              <li key={i} className="px-6 hover:text-indigo-400">
                <a href={menu?.link}>{menu?.name}</a>
              </li>
            ))}
            <li>
              <Link to="/blog" className="px-6 hover:text-indigo-400">
                BLOG
              </Link>
            </li>
          </ul>
        </div>
        <div
          onClick={() => setOpen(!open)}
          className={`z-[999]  ${
            open ? "text-gray-200" : "text-gray-100"
          } text-3xl md:hidden m-5`}
        >
          <ion-icon name="menu"></ion-icon>
        </div>
        <div
          className={`md:hidden text-gray-200 absolute w-2/3 h-screen
      px-7 py-2 font-medium bg-indigo-900 top-0 duration-300 ${
        open ? "right-0" : "right-[-100%]"
      }`}
        >
          <ul className="flex flex-col justify-center h-full gap-10 py-2 text-lg">
            <li onClick={() => setOpen(!open)}>
              <Link to="/" className="px-6 hover:text-indigo-400">
                HOME
              </Link>
            </li>
            {menuLinks?.map((menu, i) => (
              <li
                onClick={() => setOpen(!open)}
                key={i}
                className="px-6 hover:text-indigo-600"
              >
                <a href={menu?.link}>{menu?.name}</a>
              </li>
            ))}
            <li onClick={() => setOpen(!open)}>
              <Link to="/blog" className="px-6 hover:text-indigo-400">
                BLOG
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
